'use strict'

import React from 'react';
import uuid from 'uuid';

import AreaForm from '../components/AreaForm.jsx'
import ProjectMenu from '../components/ProjectMenu.jsx';
import Layout from '../Layout.jsx';

import formDefinition from './formDefinition.js';
import stageForm from './stageFormDefinition.js';

import {ProjectPlan} from '../ProjectPlan.jsx';
import StagePlan from './StagePlan.jsx';
import LessonDetails, {LessonStatement} from './LessonDetails.jsx';
import PhaseTransition from './PhaseTransition.jsx';
import ExceptionManagement from './ExceptionManagement.jsx';
import LessonFilterAdvanced from './LessonFilterAdvanced.jsx';
import BaselineHistory from './BaselineHistory.jsx';

import sendCommand from '../../app/utils/sendCommand.js';

import Translations from '../../app/utils/translations.js';
let translations=new Translations([
  require('./labels/english.js'),
  require('./labels/norwegian.js')
]).loadVariants([
  require('./labels/product/english#productPlan.js'),
  require('./labels/product/norwegian#productPlan.js'),
]);

import FormattedContent from '../components/FormattedContent.jsx';
import setupStageBudget from './setupStageBudget.js';

function parseDate(date) {
  try {
    let parsedDate=date!==undefined && date!==null && date.length>0
      ? new Date(date).toISOString().slice(0,10)
      : undefined;
    if (parsedDate!==date) {
      return date;
    } else {
      return parsedDate;
    }
  } catch (error) {
    return date;
  }
}

function formatNumber(value,column,context) {
  return column==="hours" || column==="expences" || column==="investments" || column==="sum" || column==="costTolerance" || column==="cost" || column==="tolerance"
    ? <div style={{textAlign: "right"}}>{value!==undefined && value!==null ? value.replace(/\B(?=(\d{3})+(?!\d))/g, context.language!=="norwegian" ? "," : " ") : ""}</div>
    : <FormattedContent value={value}/>;
}

function stageToTableView(stage,props) {
  return Object.assign({},stage,{
    start: stage.time!==undefined ? parseDate(stage.time.start) : undefined,
    end: stage.time!==undefined ? parseDate(stage.time.end) : undefined,
    timeTolerance: stage.time!==undefined ? formatTimeTolerance(stage.time,props) : undefined,
    hours: stage.cost.hours,
    expences: stage.cost.expences,
    investments: stage.cost.investment,
    sum: stage.cost.sum,
    costTolerance: stage.cost.tolerance,
    _displayAs: stage.active ? "_highlight" : stage.historic ? "_disabled" :  stage.requestedTransitionTo ? "" : "_normal",
    _format: stage.requestedTransitionTo===true || stage.requestedException===true || stage.actuals ===true ? (value,column,context)=>{
      return column==="name" ? (
        <span><FormattedContent value={value}/>{stage.actuals===true ? (<span style={{float:"right", color: "darkgrey", paddingRight:5}}>&#x2713;</span>) : <img src={"/images/"+(stage.requestedTransitionTo===true ? "Flag_FinishGrey_22x16.gif" : "Flag_DarkGrey_22x16.gif")} style={{paddingLeft:10,height:19}}/>}</span>
      ) : formatNumber(value,column,context)
    } : formatNumber
  });
}

function translateTimeTolerance(stageTime,props) {
  let stage={
    time: stageTime
  };
  if (stage.time.tolerance!==undefined && stage.time.tolerance!==null) {
    try {
      var unit=stage.time.tolerance.split(" ")[1].toLowerCase();
      let number=stage.time.tolerance.split(" ")[0];
      let unitOptions=translations.getTranslation(props).stageTime.fields.timeToleranceUnit.options;
      if (unitOptions[unit]===undefined) {
        if (unitOptions[unit+(unit.slice(-1)!=="s" ? "s" :"")]!==undefined) {
          unit=unit+(unit.slice(-1)!=="s" ? "s" :"");
        };
      }
      if (unitOptions[unit]===undefined) {
        let values=Object.keys(unitOptions)
          .map(key=>unitOptions[key])
          .map(value=>value.toLowerCase());
        if (values.includes(unit)) {
          unit=Object.keys(unitOptions)[values.indexOf(unit)];
        } else if (values.includes(unit+"er")) {
          unit=Object.keys(unitOptions)[values.indexOf(unit+"er")];
        }
      }

      if (unitOptions[unit]!==undefined) {
        return {value:number, unit:unit};
      } else {
        stage.timeTolerance=stage.time.tolerance;
        return {value:stage.time.tolerance};
      }
    } catch (error) {
      return {value:stage.time.tolerance};
    }
  } else {
    return {value: stage.time.tolerance};
  }

}

export function formatTimeTolerance(stageTime, props) {
  let tolerance=translateTimeTolerance(stageTime,props);
  return formatTolerance(tolerance,props);
}

function formatTolerance(tolerance,props) {
  let labels=translations.getTranslation(props).stageTime.fields.timeToleranceUnit.options;
  let unit=tolerance.unit!==undefined ? " "+labels[tolerance.unit].toLowerCase() : "";
  let formatedTolerance=tolerance.value!==undefined && tolerance.value!==null && tolerance.value!=="null" ? tolerance.value+unit : "";
  return formatedTolerance;
}

class LessonFilterItem extends React.Component {
  selected(event) {
    this.props.onChange({type:this.props.id, onlyProject:this.props.onlyProject});
  }

  render() {
    return (
      <span style={{paddingRight:20}}>
        <input onChange={this.selected.bind(this)} defaultChecked={this.props.checked} type="radio" id={this.props.id} name="lessons"/> <label htmlFor={this.props.id}>{this.props.label}</label>
      </span>
    );
  }
}

class LessonsFilter extends React.Component {
  render() {
    let categoryLabels=translations.getTranslation(this.props).summary.fields.type.options;
    let labels=translations.getTranslation(this.props).general.lessons;
    return (
      <div>
        {[
          "project",
          this.props.tenant.portfolios!==undefined && this.props.tenant.portfolios.length>0 ? "portfolio" : undefined,
          "corporate"
        ]
        .filter(item=>item!==undefined)
        .map(item=>
          <LessonFilterItem
            id={item}
            label={categoryLabels[item]}
            checked={item===this.props.selected}
            onlyProject={this.props.onlyProject}
            onChange={this.props.onChange}
          />
        )}
        {this.props.selected!=="project" ? (
          <span>
            <input onClick={(event)=>this.props.onChange({type: this.props.selected, onlyProject:event.target.checked})} type="checkbox" id="projectOnly" defaultChecked={this.props.onlyProject}/>
            <span> </span>
            <label htmlFor="projectOnly">{labels.onlyProject}</label>
          </span>
        ) : null}
        {this.props.selected!=="project" && this.props.onlyProject!==true ? (
          <LessonFilterAdvanced
            {...this.props}
            onChange={(filter,keywords)=>this.props.onChange({
              type:this.props.selected,
              onlyProject: this.props.onlyProject,
              filter: filter,
              keywords: keywords
            })}
            limitToPortfolio={this.props.selected==="portfolio" ? this.props.project.portfolio : undefined}
          />
        ) : null}
      </div>
    );
  }
}


export function setupSchedule(stages,props) {
  let labels=translations.getTranslation(props).general.stagePlan;
  var schedule;
  if (props.planVersion==="2") {
    if (props.projectType===undefined || props.projectType.phases===undefined) {
      schedule=[
        {
          id:"_project",
          text: labels.projectPhase,
          items: stages!==undefined ? stages.map(stage=>stageToTableView(stage,props)) : undefined
        }
      ];
    } else {
      var currentPhaseIndex=-1;
      props.projectType.phases.forEach((phase,index)=>{
        if (props.project.currentPhase!==undefined && props.project.currentPhase.id===phase.id) {
          currentPhaseIndex=index;
        }
      });
      schedule=props.projectType.phases.map((phase,index)=>Object.assign({},phase,{
        _displayAs: props.project.currentPhase!==undefined && props.project.currentPhase.id===phase.id
          ? "_highlight"
          : props.project.requestedPhase!==undefined && props.project.requestedPhase.id===phase.id
            ? "_normal"
            : undefined,
        items: stages!==undefined ? stages.filter(stage=>stage.phase!==undefined && stage.phase.id===phase.id).map(stage=>stageToTableView(stage,props)) : [],
        _disableOption: index<currentPhaseIndex ? ["addEntry"] : undefined,
      }));
      let hasInvalidPhase=(stage,phasesInProjectType)=>{
        return stage.phase===undefined
          || stage.phase.id===undefined
          || stage.phase!==undefined
            && stage.phase.id!==undefined
            && phasesInProjectType!==undefined
            && phasesInProjectType
              .filter(phase=>phase.id===stage.phase.id)
              .length===0;
      };
      if (stages!==undefined
        && stages
          .filter(stage=>hasInvalidPhase(stage,props.projectType.phases))
          .length>0
        ) {
        schedule=[].concat({
          id:"_project",
          text: "("+labels.projectPhase+")",
          items: stages
            .filter(stage=>hasInvalidPhase(stage,props.projectType.phases))
            .map(stage=>stageToTableView(stage,props))
        })
        .concat(schedule);
      }
    }
  }
  return schedule;
}

export function addTotalsToSchedule(schedule,props) {
  let labels=translations.getTranslation(props).general.stagePlan;
  let sortByStart=(a,b)=> a.time.start<b.time.start ? -1 : a.time.start>b.time.start ? 1 : 0;
  let sortByEnd=(a,b)=>a.time.end>b.time.end ? -1 : a.time.end<b.time.end ? 1 : 0
  let startOf=(stages)=>{
    let sortedStages=(stages!==undefined ? stages : [])
        .filter(stage=>stage!==undefined)
        .filter(stage=>stage.time!==undefined && stage.time.start!==undefined && stage.time.start!==null && stage.time.start.trim().length>0)
        .slice().sort(sortByStart);
      return sortedStages.length>0 && sortedStages[0].time!==undefined ? sortedStages[0].time.start : undefined;
  };
  let endOf=(stages)=>{
    let sortedStages=(stages!==undefined ? stages : [])
      .filter(stage=>stage!==undefined)
      .filter(stage=>stage.time!==undefined && stage.time.end!==undefined && stage.time.end!==null && stage.time.end.trim().length>0)
      .slice().sort(sortByEnd);
    return sortedStages.length>0 && sortedStages[0].time!==undefined ? sortedStages[0].time.end : undefined;
  }
  let sumCost=(stages,field)=>{
    let valueOf=(fieldValue)=>{
      let parsedValue=parseInt(fieldValue);
      let calculatedValue=!isNaN(parsedValue) && fieldValue==parsedValue ? parsedValue : 0;
      return calculatedValue;
    }
    return stages!==undefined ?
      stages
        .filter(stage=>stage!==undefined)
        .reduce((sum,stage)=>sum+valueOf(stage.cost[field]),0)+"" : 0;
  }

  let sumTimeTolerance=(stages)=>{
    let days=stages
      .filter(stage=>stage!==undefined)
      .map(stage=>translateTimeTolerance(stage.time,props))
      .filter(tolerance=>tolerance.value!==null && tolerance.value!==undefined && tolerance.value!=="null")
      .map(tolerance=>tolerance.unit==="days"
        ? parseInt(tolerance.value)
        : tolerance.unit==="weeks"
          ? parseInt(tolerance.value)*5
          : tolerance.unit==="months"
            ? parseInt(tolerance.value)*21.5
            : 0
      )
      .reduce((sum,item)=>sum+(isNaN(item) ? 0 : item),0);
    var sumTolerance={value:days.toString(),unit:"days"};
    if (days>=21) {
      sumTolerance={value:(days/21.5).toFixed(1), unit:"months"};
    } else if (days>=5) {
      sumTolerance={value:(days/5).toFixed(1), unit:"weeks"};
    }
    if (sumTolerance.value.indexOf(".0")>0) {
      sumTolerance.value=sumTolerance.value.split(".")[0];
    }
    if (props.language==="norwegian" && sumTolerance.value.indexOf(".")>0) {
      sumTolerance.value=sumTolerance.value.replace(".",",");
    }
    return formatTolerance(sumTolerance,props);
  }

  var updatedSchedule=schedule!==undefined
  ? schedule
    .map(phase=>Object.assign({},phase,{
      items:phase.items!==undefined && phase.items.length>0
        ? phase.items.concat({
            id:"_"+phase.id+"_total",
            name: labels.totalStagePrefix+" "+phase.text,
            type:"total",
            start : startOf(phase.items),
            end: endOf(phase.items),
            timeTolerance: sumTimeTolerance(phase.items),
            hours: sumCost(phase.items,"hours"),
            expences: sumCost(phase.items,"expences"),
            investments: sumCost(phase.items,"investment"),
            sum: sumCost(phase.items,"sum"),
            costTolerance: sumCost(phase.items,"tolerance"),
            _format: formatNumber
          })
        : phase.items
      }))
    : undefined;

  let stages=schedule!==undefined ? [].concat.apply([],schedule.map(phase=>phase.items)) : undefined;
  let doesNotHavePhases=schedule!==undefined && schedule.length<=1;
  if (!doesNotHavePhases && updatedSchedule!==undefined) {
    updatedSchedule=updatedSchedule.concat({
      id: "_totals",
      text: "",
      type:"total",
      _hideColumnHeader: ["stage"],
      _disableOption:["addEntry"],
      items: [{
        id:"_totalStage",
        name:labels.totalPhase,
        start: startOf(stages),
        end: endOf(stages),
        hours: sumCost(stages,"hours"),
        timeTolerance: sumTimeTolerance(stages),
        expences: sumCost(stages,"expences"),
        investments: sumCost(stages,"investment"),
        sum: sumCost(stages,"sum"),
        costTolerance: sumCost(stages,"tolerance"),
        _format: formatNumber
      }]
    });
  }
  return updatedSchedule;
}


function adjustFormForType(formDefinition,type) {
  if (type!==undefined) {
    let updatedForm=
      formDefinition
        .filter(item=>item._excludedFor===undefined || !item._excludedFor.includes(type))
        .map(area=>Object.assign({},area,{
          fields: area.fields.filter(item=>item._excludedFor===undefined || !item._excludedFor.includes(type))
        }));
    return updatedForm;
  } else {
    return formDefinition;
  }
}


function lessonIncludedByFilter(lesson,filter) {
  const age=(new Date().getTime() - new Date(lesson.identified).getTime()) / (1000*60*60*24*365);
  const content=[]
    .concat(lesson.source!==undefined && lesson.source.type!==undefined ? "projectType_"+lesson.source.type : "")
    .concat(lesson.source!==undefined && lesson.source.category!==undefined ? "category_"+lesson.source.category : "")
    .concat(lesson.source!==undefined && lesson.source.portfolio!==undefined ? "portfolio_"+lesson.source.portfolio : "")
    .concat(lesson.source!==undefined && lesson.source.location!==undefined ? "location_"+lesson.source.location : "")
    .concat(lesson.source!==undefined && lesson.source.state!==undefined ? "state_"+lesson.source.state : "")
    .concat(age<1
      ? "time_lessThan12Months"
      : age>=1 && age<3
        ? "time_oneToThreeYears"
        : age>=3 && age<5
          ? "threeToFiveYears"
          : "time_moreThanfiveYears")
    .filter(value=>value.length>0)
  return content.reduce((found,classification)=>found && filter[classification]===true, true);
}

function lessonIncludedByKeywords(lesson, keywords) {
  const searchFor=keywords.split(",");
  const content=[]
    .concat(lesson.title)
    .concat(lesson.effect)
    .concat(lesson.event)
    .concat(lesson.cause)
    .concat(lesson.source!==undefined && lesson.source!==null ? lesson.source.name : "")
    .concat(lesson.indicators)
    .concat(lesson.recommendations)
    .concat(lesson.author!==undefined && lesson.author!==null ? lesson.author.name : "");
  return searchFor.reduce((found,criteria)=>
    found && content.reduce((foundForCriteria,item)=>
      foundForCriteria || item!==undefined && item.length>0 && item.toLowerCase().indexOf(criteria.trim().toLowerCase())>=0
      , false
    ), true
  );
}

export class Plan extends React.Component {

  constructor(props) {
    super(props);
    var selected=props.project.approach!==undefined && props.showApproach===true ? 1 : 0;
    if (typeof window!=="undefined" && window.location.hash.length>0) {
      formDefinition.forEach((area,index) =>{
        if (area.name===window.location.hash.slice(1)) {
          selected=index;
          if (props.showApproach!==true) {
            selected=selected-1;
          }
        }
      })
    }
    var lastTab="lessons";
    var visibleTabs={
      schedule:true,
      lessons:this.props.project.isProduct!==true
    };
    if (props.showApproach) {
      visibleTabs.planApproach=true;
    }
    if (props.showControls) {
      visibleTabs.projectControls=true;
      lastTab="projectControls";
    }
    let priorityLabels=translations.getTranslation(props).summary.fields.priority.options;
    let lessonFilter={type: "project", onlyProject:true};
    this.state={
      project: props.project,
      visibleTabs: visibleTabs,
      plan:this.updateLessonsInPlan(
        Object.assign({}, props.project.approach,{
          id: props.project.approach!==undefined ? "definedApproach" : undefined,
          lessonLog: [],
          _progress:lastTab,
          stages: props.project.stages,
          projectControls: props.project.projectControls!==undefined ? props.project.projectControls.projectControls : "",
          schedule: this.configureSchedule(props.project.stages,props)
        }),
        props.lessons,
        lessonFilter
      ),
      browsedCorporateLessons: props.project.browsedCorporateLessons,
      lessons: props.lessons,
      selected: selected,
      lessonFilter: lessonFilter,
      baseline: props.project.plan!==undefined ? props.project.plan.history : undefined
    };
    if (this.props.editStage!==undefined) {
      this.state=Object.assign(this.state,this.calculateStateForEditStage(this.props.editStage));
    }
  }

  configureSchedule(stages,props) {
    return setupSchedule(stages,props);
  }

  showStagePlan(stageId) {
    this.setState({showStagePlan: stageId});
  }

  cancelStagePlan(event) {
    event.preventDefault();
    this.setState({
      showStagePlan:undefined,
      selected: this.props.showApproach ? 1 : 0
    });
  }

  editFromStagePlan(event) {
    event.preventDefault();
    let id=this.state.showStagePlan;
    this.setState({showStagePlan:undefined},()=>{
      this.editStage(id);
    });
  }

  showDetails(details) {
    let labels=translations.getTranslation(this.props).general;
//    console.log("Show details: "+JSON.stringify(details));
    let schedule="schedule";
    if (details.field.indexOf(schedule)===0) {
      if (details.item!==undefined && details.item.id!==undefined || this.props.project.isClosing!==true && this.props.project.isCompleted!==true) {
        let phase=details.field.slice(schedule.length+1);
        if (details.item===undefined || details.item.id===undefined) {
          if (phase==="_totals" || phase==="_project" && this.props.projectType!==undefined && this.props.projectType.phases!==undefined && this.props.projectType.phases.length>0) {
            alert("Not possible to add stage outside phase");
          } else {
            this.showStageForm(phase);
          }
        } else {
          if (details.item.id!=="__project_total" && details.item.id!=="_totalStage") {
            this.showStagePlan(details.item.id);
          }
  //        this.editStage(details.item.id);
        }
      } else {
        alert(this.props.project.isCompleted ? labels.projectIsCompleted : labels.closureInProgress);
      }
    } else {
      if (details.item.id!==undefined) {
        this.setState({showLessonDetail:details.item, details:Object.assign({},details,{item: Object.assign({},details.item,{_progress:"followUp"})})});
      } else {
        this.setState({details:Object.assign({},details,{item: Object.assign({},details.item,{_progress:"summary"})})});
      }
    }
  }

  updateLessonDetails(content) {
    let priorityLabels=translations.getTranslation(this.props).summary.fields.priority.options;
    if (content.id!==undefined) {
      let lesson=Object.assign({},content,{_currentProgress: content._progress, _progress: "followUp"});
      sendCommand({type:"updateLesson", project:{id:this.props.project.id}, lesson: content})
        .then(response=>{
          this.setState({
            plan: this.updateLessonsInPlan(this.state.plan,response.lessons,this.state.lessonFilter),
            lessons:response.lessons,
            details:content._progress==="followUp" ? undefined : Object.assign({},this.state.details,{item:lesson}),
            selected:content._progress==="followUp"? 2 : undefined,
            modified:content._progress==="followUp" ? true : undefined
          });
        })
        .catch(error=>{
          console.log("Received error on updateLesson: "+error,error);
          alert("An error occured, please try again");
        });
    } else {
      let lesson=Object.assign({},content,{id: uuid.v4(),_currentProgress: content._progress, _progress: "followUp"});
      sendCommand({type:"recordLesson", project:{id:this.props.project.id}, lesson: lesson})
        .then(response=>{
          this.setState({
            plan: this.updateLessonsInPlan(this.state.plan,response.lessons,this.state.lessonFilter),
            lessons:response.lessons,
            details: Object.assign({},this.state.details,{item:lesson}),
            modified:undefined
          });
        })
        .catch(error=>{
          console.log("Received error on recordLesson: "+error,error);
          alert("An error occured, please try again");
        });
    }
  }

  showStageForm(phaseId) {
    let labels=translations.getTranslation(this.props).general
    this.setState({addStage:true, phase: phaseId, stageDetails:{budget:[
      { id: "hours", element: labels.hours },
      { id: "expences", element: labels.expences },
      { id: "investment", element: labels.investment },
      { id: "total", element: labels.total }
    ]}});
  }

  calculateStateForEditStage(stageId,phaseId) {
    let labels=translations.getTranslation(this.props).general
    var stage=Object.assign({},this.state.plan.stages.filter(stage=>stage.id===stageId)[0]);
    stage.budget=setupStageBudget(stage,labels).map(item=>Object.assign({},item,{_format:formatNumber}));
    var hasPeriodParsingIssueOccured=false;
    if (stage.time!==undefined ) {
      let start;
      try {
        start=new Date(stage.time.start).toISOString().slice(0,10);
        hasPeriodParsingIssueOccured=hasPeriodParsingIssueOccured || start!==stage.time.start;
      } catch (error) {
        start=undefined;
        hasPeriodParsingIssueOccured=true;
      }

      let end;
      try {
        end=new Date(stage.time.end).toISOString().slice(0,10);
        hasPeriodParsingIssueOccured=hasPeriodParsingIssueOccured || end!==stage.time.end;
      } catch (error) {
        end=undefined;
        hasPeriodParsingIssueOccured=true;
      }

      stage.period={from:start, to:end};
    }
    if (stage.isRelease===true) {
      hasPeriodParsingIssueOccured=false;
    }
    if (stage.time!==undefined) {
      let translatedTimeTolerance=translateTimeTolerance(stage.time,this.props);
      stage.timeTolerance=translatedTimeTolerance.value;
      stage.timeToleranceUnit=translatedTimeTolerance.unit;
    }
    stage.description=stage.comments;

    return {
      addStage:true,
      phase:stage.phase!==undefined ? stage.phase.id : undefined,
      stageDetails: Object.assign({},stage,{
        showStagePeriodWarning: hasPeriodParsingIssueOccured
      }),
      modifiedStage: false
    };
  }

  editStage(stageId,phaseId) {
    this.setState(this.calculateStateForEditStage(stageId,phaseId));
  }

  cancelStage(event) {
    event.preventDefault();
    this.setState({
      addStage:false,
      selected: this.props.showApproach ? 1 : 0,
      stageDetails: undefined
    });
  }

  cancelStageForm(event) {
    event.preventDefault();
    let stage=this.state.stageDetails;
    this.setState({
      addStage:false,
      selected: this.props.showApproach ? 1 : 0,
      showStagePlan: this.state.stageDetails!==undefined ? this.state.stageDetails.id : undefined,
      stageDetails: undefined
    });
    if (this.props.editRelease===true) {
      window.location="/releases/"+stage.id+"/plan";
    }
  }

  reloadStage(stage) {
    let stages=this.state.project.stages.map(item=>item.id===stage.id ? stage : item);
    this.setState({
      project: Object.assign({},this.state.project,{stages:stages}),
      stageDetails: Object.assign({},stage,{
        _currentProgress: stage._progress,
        showStagePeriodWarning: false
      }),
      modifiedStage: undefined,
      plan: Object.assign({},this.state.plan,{
        schedule: this.configureSchedule(stages,this.props),
        stages: stages
      })
    });
  }

  updatedStage(stage) {
    let id=stage.id!==undefined ? stage.id : uuid.v4()
    sendCommand({
      type: this.props.project.isProduct!==true && this.props.project.isRelease!==true
        ? stage.id!==undefined ? "updateStage" : "addStage"
        : stage.id!==undefined ? "updateRelease" : "addRelease",
      stage: Object.assign({},stage,{
        id: id,
        phase: this.state.stageDetails.phase!==undefined ? this.state.stageDetails.phase : this.state.phase!=="_project" ? {id: this.state.phase} : undefined,
      }),
      project: {id: this.props.project.isRelease===true ? this.props.project.product.id : this.props.project.id}
    })
      .then(response=>{
        this.setState({
          project: Object.assign({},this.state.project,{stages:response.stages}),
          stageDetails: Object.assign({},response.stages.filter(item=>item.id===id)[0],{
            _currentProgress: stage._progress,
            showStagePeriodWarning: false
          }),
          modifiedStage: undefined,
          plan: Object.assign({},this.state.plan,{
            schedule: this.configureSchedule(response.stages,this.props),
            stages: response.stages
          })
        });
        if (this.props.editRelease===true) {
          window.location="/releases/"+stage.id+"/plan";
        }
      })
      .catch(error=>{
        console.log("Received "+error,error);
        alert("An error occured, please try again");
      });
  }

  updateLessonsInPlan(plan,lessons,lessonFilter) {
    let priorityLabels=translations.getTranslation(this.props).summary.fields.priority.options;
    let filteredLessons=(
        lessons!==undefined
        ? lessons.map(lesson=>Object.assign({},lesson,{
          priorityLabel:priorityLabels[lesson.priority]
        }))
        : []
      )
      .filter(item=>!lessonFilter.onlyProject
        || lessonFilter.onlyProject
          && (item.source.id===this.props.project.id
            || item.applied!==undefined
              && item.applied
                .filter(appliedBy=>appliedBy.id===this.props.project.id)
                .length>0
          )
      )
      .filter(item=>
        lessonFilter.type==="project" && item.source.id===this.props.project.id
        || lessonFilter.type!=="project" && item.type===lessonFilter.type
      )
      .filter(item=>lessonFilter.filter!==undefined ? lessonIncludedByFilter(item,lessonFilter.filter): true)
      .filter(item=>lessonFilter.keywords!==undefined && lessonFilter.keywords.length>0 ? lessonIncludedByKeywords(item,lessonFilter.keywords) : true)
      .filter(item=>lessonFilter.type!=="portfolio"
        || lessonFilter.type==="portfolio"
          && (item.source.portfolio===undefined
            || item.source.portfolio===this.props.project.portfolio
          )
      )
      .map((item,index)=>Object.assign({},item,{
        no:index+1,
        _displayAs:
          lessonFilter.type==="project"
            ? item.type!=="project"
              ? "_normal"
              : ""
            : item.source.id===this.props.project.id
              ? "_normal"
              : item.applied!==undefined && item.applied.filter(appliedBy=>appliedBy.id===this.props.project.id).length>0
                ? "_highlight"
                : ""
      }));
    return Object.assign({},plan, {
        lessonLog: filteredLessons,
      });
  }

  filterLessons(lessonFilter) {
    if (this.state.browsedCorporateLessons===undefined) {
      if (lessonFilter.type==="corporate" && lessonFilter.onlyProject!==true) {
        sendCommand({type:"browsedCorporateLessons", project: {id:this.props.project.id}})
          .then(response=>this.setState({browsedCorporateLessons: true}))
          .catch(error=>console.log("Not able to record project state change"));
      }
    }
    this.setState({
      plan: this.updateLessonsInPlan(this.state.plan,this.state.lessons,lessonFilter),
      lessonFilter:lessonFilter,
      modified:true
    });
  }

  updateProject(project) {
    this.setState({
      project: project,
      plan: Object.assign({},this.state.plan, {
        schedule: this.configureSchedule(project.stages,Object.assign({},this.props,{
          project:project
        })),
        stages: project.stages
      }),
      baseline: project.plan!==undefined ? project.plan.history : undefined,
      modified: true
    });
  }

  showContent(area) {
    switch (area) {
      case "schedule":
        return this.props.planVersion!=="2" ? (
          <ProjectPlan
            {...this.props}
            project={Object.assign({},this.props.project, {stages: this.state.plan.stages})}
            onSubmit={this.submitPlanChanges.bind(this)}
            onAddStage={this.props.planVersion==="2" ? this.showStageForm.bind(this) : undefined}
            onEditStage={this.props.planVersion==="2" ? this.editStage.bind(this) : undefined}
          />
      ) : (
        <div>
          <PhaseTransition
            {...this.props}
            project={this.state.project}
            schedule={this.state.plan.schedule}
            onUpdate={this.updateProject.bind(this)}
          />
          <ExceptionManagement
            {...this.props}
            project={this.state.project}
            schedule={this.state.plan.schedule}
            onUpdate={this.updateProject.bind(this)}
            baseline={this.props.project.plan}
          />
        </div>
      );
      case "lessons":
        return (
          <LessonsFilter
            {...this.props}
            selected={this.state.lessonFilter.type}
            onlyProject={this.state.lessonFilter.onlyProject}
            onChange={this.filterLessons.bind(this)}
          />
        );
      default:
        let labels=translations.getTranslation(this.props);
        return (
          <i>{labels[area].description}</i>
        );
    }
  }

  getFormValues(form,defaultValues) {
    var formValues=Object.assign({},defaultValues);
    if (form!==undefined && form!==null) {
      for (var i=0; i<form.elements.length; i++) {
        var value=form.elements[i].value;
        if (value.trim().length===0) {
          value=undefined;
        }
        if (form.elements[i].name!==undefined && form.elements[i].name.trim().length>0) {
          formValues[form.elements[i].name]=value;
        }
      }
    }
    formValues.cancel=undefined;
    formValues.save=undefined;
    return formValues;
  }

  submitPlanChanges(event) {
    event.preventDefault();
    return new Promise((resolve,reject)=>{
      sendCommand({type:"updatePlan", form: this.getFormValues(event.target), project:{id:this.props.project.id}})
        .then((response)=>{
          let updatedPlan=Object.assign({},this.state.plan,{stages: response.plan,_currentProgress:"schedule"});
          this.setState({plan:updatedPlan, lastSaved:updatedPlan,selected:1,modified:true});
          resolve(response.plan);
        })
        .catch(error=>reject(error));
    })
  }

/*
  submitLesson(event) {
    event.preventDefault();
    this.updateLessonDetails(this.getFormValues(event.target,this.state.details.item));
  }
*/
  canceledDetails() {
    this.setState({details:undefined, selected: this.props.showApproach ? 2 : 1});
  }

  saveApproach(event) {
    if (event._progress==="projectControls") {
      let projectControls=event.projectControls;
      sendCommand({type:"updateProjectControls", project:{id:this.props.project.id}, projectControls:projectControls})
        .then(response=>{
          this.setState({plan:Object.assign({},this.state.plan, Object.assign({},{projectControls:response.projectControls},{id: "definedProjectControls", _currentProgress:"projectControls"}))});
        })
        .catch(error=>{
          console.log("Got error "+JSON.stringify(error),error);
          alert("Could not save project controls");
        });
    } else {
      let approach={
        methods:event.methods,
        resources:event.resources,
        technology: event.technology,
        rollOut: event.rollOut,
        other: event.other
      };
      if (event.id===undefined) {
        sendCommand({type:"defineProjectApproach", project:{id:this.props.project.id}, approach: approach})
          .then(response=>{
            this.setState({plan:Object.assign({},this.state.plan, Object.assign({},response.approach,{id: "definedApproach", _currentProgress:"approach"}))});
          })
          .catch(error=>{
            console.log("Got error "+JSON.stringify(error),error);
            alert("Could not save approach");
          })
      } else {
        sendCommand({type:"updateProjectApproach", project:{id:this.props.project.id}, approach: approach})
          .then(response=>{
            this.setState({plan:Object.assign({},this.state.plan,
                Object.assign({},response.approach,{_currentProgress:"approach"})
              )
            });
          })
          .catch(error=>{
            alert("Could not save approach, "+JSON.stringify(error));
          })
      }
    }
  }

  lessonSummary(tab, details) {
    let labels=translations.getTranslation(this.props).general.statement;
    let containsStatement=
      details.values.effect!==undefined && details.values.effect.trim().length>0 ||
      details.values.event!==undefined && details.values.event.trim().length>0 ||
      details.values.cause!==undefined && details.values.cause.trim().length>0
    return (
      <div>
        {tab!=="summary" ? (
          <div style={{fontWeight: "bold"}}>{details.values.title}</div>
        ) : null}
        {containsStatement || tab==="detail" ? (
          <div style={{paddingTop: 5}}>
            <LessonStatement {...this.props} lesson={details.values}/>
          </div>
        ) : null}
      </div>
    );
  }

  handleLessonFieldChange(fieldname) {
    return (event)=>{
      this.setState({
        details: Object.assign({},this.state.details, {
          item:Object.assign({},this.state.details.item,{[event.target.name]:event.target.value})}),
        modified:true
      });
    };
  }

  handleStageFieldChange(fieldname) {
    return (event)=>{
      this.setState({
        stageDetails:Object.assign({},this.state.stageDetails,{[event.target.name]:event.target.value}),
        modifiedStage: true,
      })
    };
  }

  addTotals(plan) {
    let updatedSchedule=addTotalsToSchedule(plan.schedule,this.props);
    return Object.assign({},plan,{
      schedule: updatedSchedule
    });
  }

  moveStage(stageId, phaseId) {
    sendCommand({type:"moveStage", stage: {id: stageId}, phase: {id: phaseId}, project: {id: this.props.project.id}})
      .then(response=>{
        this.setState({
          plan: Object.assign({},this.state.plan,{
            schedule: this.configureSchedule(response.stages,this.props),
            stages: response.stages
          })
        })
      })
      .catch(error=>{
        console.log("Got response: "+error,error);
        alert("An error occured, please try again.");
      });
  }

  applyLesson(lessonId) {
    return new Promise((resolve,reject)=>{
      sendCommand({type: "applyLesson", project: {id: this.props.project.id}, lesson:{id: lessonId}})
        .then(response=>{
          resolve(response.lessons);
        })
        .catch(error=>reject(error))
    });
  }

  unapplyLesson(lessonId) {
    return new Promise((resolve,reject)=>{
      sendCommand({type: "unapplyLesson", project: {id: this.props.project.id}, lesson:{id: lessonId}})
        .then(response=>{
          resolve(response.lessons);
        })
        .catch(error=>reject(error))
    });
  }

  deleteLesson(lessonId) {
    return new Promise((resolve,reject)=>{
      sendCommand({type: "deleteLesson", project: {id: this.props.project.id}, lesson:{id: lessonId}})
        .then(response=>{
          resolve(response.lessons);
        })
        .catch(error=>reject(error))
    });
  }

  deleteStage(stageId) {
    return new Promise((resolve,reject)=>{
      var command={};
      if (this.props.project.isProduct!==true && this.props.project.isRelease!==true) {
        command={type: "deleteStage", forcedDelete: this.props.deleteEnabled, project: {id: this.props.project.id}, stage:{id: stageId}};
      } else {
        command={type: "deleteRelease", forcedDelete: this.props.deleteEnabled, product: {id: this.props.project.id}, release:{id: stageId}};
      }
      sendCommand(command)
        .then(response=>{
          resolve(response.stages);
          resolve(this.state.plan.stages.filter(stage=>stage.id!==stageId));
        })
        .catch(error=>reject(error))
    });
  }

  showStagePeriodWarning(tab) {
    let labels=translations.getTranslation(this.props).general;
    let warning=(this.state.stageDetails.showStagePeriodWarning) ? (
      <div style={{color:"#212121", padding:10, marginTop: 10, fontFamily:"Lato", textAlign:"center", backgroundColor:"#FFEADB"}}>
        Stage period might have been parsed wrongly, please ensure that
        <span> </span>
        "<i>{this.state.stageDetails.period.from instanceof Date ? this.state.stageDetails.period.from.toISOString().slice(0,10) : this.state.stageDetails.period.from} - {this.state.stageDetails.period.to instanceof Date ? this.state.stageDetails.period.to.toISOString().slice(0,10) : this.state.stageDetails.period.to}</i>" means the same as "<i>{this.state.stageDetails.time.start} - {this.state.stageDetails.time.end}</i>".
      </div>
    ) : null;
    let currency=(tab==="stageCost" && this.props.project.currency!==undefined) ? (
      <div>
        {labels.currency.replace("{currency}",this.props.project.currency)} <a href={"/projects/"+this.props.project.id+"/properties"}>{labels.projectPropertiesLink}</a>.
      </div>
    ) : null;
    return currency || warning ? (
      <div>
        {warning}
        {currency}
      </div>
    ) : null;
  }

  addCurrencyLabel(area) {
    let currency=this.props.project.currency!==undefined ? this.props.project.currency : undefined;
    return area.name!=="schedule" || currency===undefined
      ? area
      : Object.assign({},area,{
          fields: area.fields.map(field=>
            field.name!=="schedule"
              ? field
              : Object.assign({},field, {
                columnHeaders: field.columnHeaders.map(header=>
                  header.name!=="cost"
                    ? header
                    : Object.assign({},header, {
                      title: header.title+" ("+currency+")"
                    })
                )
              })
          )
        });
  }

  render() {
    let labels=translations.getTranslation(this.props).general;
    let areas=translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant)
      .filter(area=>this.state.visibleTabs[area.name]===true)
      .map(area=>area.name==="schedule" && this.props.planVersion!=="2"
        ? Object.assign({},area,{ fields: undefined })
        : this.addCurrencyLabel(area)
      );
    return this.state.showLessonDetail!==undefined ? (
      <div style={{paddingTop: 20, display:"flex", justifyContent:"center"}}>
        <div style={{width:1016}}>
          <LessonDetails
            {...this.props}
            onCancel={()=>this.setState({
              showLessonDetail:undefined,
              details:undefined,
              selected: this.props.showApproach ? 2 : 1
            })}
            onEdit={()=>this.setState({showLessonDetail:undefined})}
            onApply={()=>
              this.applyLesson(this.state.showLessonDetail.id)
                .then((lessons)=>this.setState({
                  showLessonDetail:undefined,
                  details:undefined,
                  plan:this.updateLessonsInPlan(this.state.plan,lessons,this.state.lessonFilter),
                  lessons: lessons,
                  selected: this.props.showApproach ? 2 : 1
                }))
                .catch(error=>{
                  console.log("Got error "+error,error);
                  alert("An error occured, please try again")
                })
            }
            onUnapply={()=>
              this.unapplyLesson(this.state.showLessonDetail.id)
                .then((lessons)=>this.setState({
                  showLessonDetail:undefined,
                  details:undefined,
                  plan:this.updateLessonsInPlan(this.state.plan,lessons,this.state.lessonFilter),
                  lessons: lessons,
                  selected: this.props.showApproach ? 2 : 1
                }))
                .catch(error=>{
                  console.log("Got error "+error,error);
                  alert("An error occured, please try again")
                })
            }
            onDelete={()=>
              this.deleteLesson(this.state.showLessonDetail.id)
                .then((lessons)=>this.setState({
                  showLessonDetail:undefined,
                  details:undefined,
                  plan:this.updateLessonsInPlan(this.state.plan,lessons,this.state.lessonFilter),
                  lessons: lessons,
                  selected: this.props.showApproach ? 2 : 1
                }))
                .catch(error=>{
                  console.log("Got error "+error,error);
                  alert("An error occured, please try again")
                })
            }
            lesson={this.state.showLessonDetail}
          />
        </div>
      </div>
    ) : this.state.showStagePlan!==undefined ? (
      <div>
        <StagePlan
          {...this.props}
          path={"plan/"+(this.props.project.isProduct===true ? "releases/" : "stages/")+this.state.showStagePlan}
          stage={this.state.plan.stages.find(stage=>stage.id===this.state.showStagePlan)}
          project={this.state.project}
          projectType={this.props.projectType}
          onCancel={this.cancelStagePlan.bind(this)}
          onEdit={this.editFromStagePlan.bind(this)}
          onMoveStage={this.moveStage.bind(this)}
          onUpdate={this.updateProject.bind(this)}
          onUpdateStage={this.reloadStage.bind(this)}
        />
      </div>
    ) : this.state.addStage ? (
      <div style={{paddingTop: 20, display:"flex", justifyContent:"center"}}>
        <div style={{width:1016}}>
          <AreaForm key="stage"
            {...this.props}
            display="tab"
            areas={translations.createTranslatedForm(adjustFormForType(stageForm,this.props.project.isProduct===true || this.props.project.isRelease===true ? "product" : "project"),this.props.language,this.props.variant)}
            item={Object.assign({},this.state.stageDetails,{_progress:"stageScheduleScope"})}
            selected={0}
            summary={this.showStagePeriodWarning.bind(this)}
            label={labels.stage}
            modified={this.state.modifiedStage}
            confirmDeleteMessage={labels.stagePlan.actions.confirmDelete}
            onDelete={this.props.deleteEnabled || (this.state.stageDetails.active!==true
              && this.state.stageDetails.historic!==true
              && this.state.stageDetails.requestedTransitionTo!==true)
              ? (stage)=>{
                this.deleteStage(stage.id)
                  .then((stages)=>this.setState({
                    addStage:false,
                    selected:this.props.showApproach ? 1 : 0,
                    stageDetails: undefined,
                    plan: Object.assign({},this.state.plan,{
                      schedule: this.configureSchedule(stages,this.props),
                      stages: stages
                    })
                  }))
                  .catch(error=>{
                    console.log("Got error "+error,error);
                    alert("An error occured, please try again")
                  })
                }
              : undefined }
            onUpdate={this.updatedStage.bind(this)}
            handleFieldChange={this.handleStageFieldChange.bind(this)}
            onCancel={this.cancelStageForm.bind(this)}
          />
        </div>
      </div>
    ) : (
      <div style={{paddingTop: 20, display:"flex", justifyContent:"center"}}>
        <div style={{width:1016}}>
          {this.state.details!==undefined ? (
            <AreaForm key="details"
              {...this.props}
              display="tab"
              areas={translations.createTranslatedForm(this.state.details.form,this.props.language,this.props.variant)}
              item={this.state.details.item}
              selected={0}
              label={labels.lesson}
              onUpdate={this.updateLessonDetails.bind(this)}
              summary={this.lessonSummary.bind(this)}
              handleFieldChange={this.handleLessonFieldChange.bind(this)}
              modified={this.state.modified}
              onCancel={this.canceledDetails.bind(this)}
            />
          ) : (
            <AreaForm
              {...this.props}
              areas={areas}
              display="tab"
              label={[{name:"planApproach", label:labels.approach},{name:"projectControls", label:labels.controls}]}
              item={this.addTotals(this.state.plan)}
              modified={this.state.modified}
              selected={this.state.selected}
              summary={this.showContent.bind(this)}
              onUpdate={this.saveApproach.bind(this)}
              onAddEntry={this.showDetails.bind(this)}
              onEditEntry={this.showDetails.bind(this)}
              onCancel={()=>window.location="."}
              details={(area)=>area==="schedule" ? <BaselineHistory {...this.props} baseline={this.state.baseline}/> : undefined}
              forceReadOnly={true}
            />
          )}
        </div>
      </div>
    )
  }
}

export default class PlanPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <Plan {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/plan/Plan.jsx